import { useState, useEffect } from 'react';
import {
  Typography, TextField, Button, Table, TableBody, TableCell,
  TableHead, TableRow, Box, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import axios from 'axios';

const API = 'https://attend.zventures.in';

const EmailConfig = ({ locations }) => {
  const [configs, setConfigs] = useState([]);
  const [form, setForm] = useState({ location: '', to: '', bcc: '' });

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/api/email-config`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setConfigs(r.data))
      .catch(console.error);
  }, []);

  const updateConfig = async () => {
    if (!form.location) return;
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/api/email-config`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setConfigs(prev => [...prev.filter(c => c.location !== form.location), res.data]);
      setForm({ location: '', to: '', bcc: '' });
    } catch (err) {
      console.error('Error updating email config:', err);
    }
  };

  const locationNames = (locations || []).map(l => l.name);

  return (
    <Box sx={{ background: 'linear-gradient(to bottom right,#e6f0f9,#e6f0f9)', borderRadius: '10px', p: 3, mb: '5%' }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 400 }}>Admin Panel – Email Configuration</Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
        <FormControl sx={{ minWidth: 160, backgroundColor: 'white' }}>
          <InputLabel>Location</InputLabel>
          <Select value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} label="Location">
            {locationNames.map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
          </Select>
        </FormControl>
        <TextField
          label="To Emails (comma-separated)"
          value={form.to}
          onChange={e => setForm({ ...form, to: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }}
          sx={{ minWidth: 300 }}
          helperText="e.g. mgmt@company.com, hr@company.com"
        />
        <TextField
          label="BCC Emails (comma-separated)"
          value={form.bcc}
          onChange={e => setForm({ ...form, bcc: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }}
          sx={{ minWidth: 300 }}
          helperText="e.g. director@company.com, accounts@company.com"
        />
        <Button variant="contained" onClick={updateConfig}>Save Config</Button>
      </Box>

      <Box sx={{ borderRadius: 2, backgroundColor: '#ffffffcc', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 300, color: '#1e3a8a' }}>Configured Email List</Typography>
        <Table>
          <TableHead>
            <TableRow sx={{ background: '#f0f4ff' }}>
              <TableCell><strong>Location</strong></TableCell>
              <TableCell><strong>To</strong></TableCell>
              <TableCell><strong>BCC</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {configs.length === 0 ? (
              <TableRow><TableCell colSpan={3} align="center">No configurations saved yet</TableCell></TableRow>
            ) : configs.map(c => (
              <TableRow key={c.location}>
                <TableCell>{c.location}</TableCell>
                <TableCell sx={{ wordBreak: 'break-all' }}>{c.to}</TableCell>
                <TableCell sx={{ wordBreak: 'break-all' }}>{c.bcc}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default EmailConfig;